// extracted by mini-css-extract-plugin
module.exports = {"container":"warranties_container__3f0GZ"};